module.exports = __webpack_public_path__ + "static/media/black-shirt-formal.fb6de044.jpg";